<template>
  <div v-if="fields" class="grid grid-cols-6 gap-x-8 gap-y-4">
      <Component
        v-for="control in fields"
        :is="control.component"
        v-show="control.if ? (value[control.if.split(',')[0]] === control.if.split(',')[1] || false) : true"
        :key="control.name"
        v-model="value[control.name]"
        :control="control"
        v-bind="control.props"
      />
  </div>

</template>
<script>
const GroupControl = Vue.prototype.$GroupControl
const CheckboxControl = Vue.prototype.$CheckboxControl
const InputControl = Vue.prototype.$InputControl
const RadioControl = Vue.prototype.$RadioControl
const RateControl = Vue.prototype.$RateControl
const SelectControl = Vue.prototype.$SelectControl
const SwitchControl = Vue.prototype.$SwitchControl
const TextareaControl = Vue.prototype.$TextareaControl
const AvatarControl = Vue.prototype.$AvatarControl


export default {
  name: 'FormRenderer',
  components: {
    GroupControl,
    CheckboxControl,
    InputControl,
    RadioControl,
    RateControl,
    SelectControl,
    SwitchControl,
    TextareaControl,
    AvatarControl,
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    fields: {
      type: Array,
      required: true
    }
  },
}
</script>
